<div class="dropdown" title="{{strings.Download}}">
  <a class="btn dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    <co-image width="24" height="24" type="svg" key="download" [imageSet]="imageSet"></co-image>
  </a>

  <div class="dropdown-menu">
    <custom-link *ngFor="let graphic of graphics" class="link-{{graphic.name.toLowerCase()}}" [isRemote]="false" [url]="graphic.url" [title]="graphic.name" [showIcon]="false" [extraStyles]="'dropdown-item graphics-download-link'" [imageSet]="imageSet"></custom-link>
  </div>
</div>